"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides possible {@link IHypermediaProcessor} support levels.
 */
var Level;
(function (Level) {
    /**
     * @enum
     * @type {number}
     * Defines a not supported response.
     */
    Level[Level["None"] = 0] = "None";
    /**
     * @enum
     * @type {number}
     * Defines an exact support of the response.
     */
    Level[Level["FullSupport"] = 100] = "FullSupport";
})(Level = exports.Level || (exports.Level = {}));
//# sourceMappingURL=Level.js.map